module.exports = __webpack_public_path__ + "static/cpn-48c6366c52c8be1073499b05657756ac.pdf";